import { memo } from 'react';
import { useLocation } from 'react-router-dom';
import { dateToString } from '@/utils';
import { useGetChildEventsQuery } from '@/services/child-api';
import Table from '@/components/table';

const columns = [
  {
    title: 'Event',
    dataIndex: 'event',
    render: (value) => <a href={`/events/EventView.aspx?EventID=${value.eventId}`}>{value.name}</a>,
  },
  {
    title: 'Date',
    key: 'date',
    render: (_, record) => dateToString(record.event.eventDate.dateTime),
  },
  {
    title: 'Type',
    key: 'type',
    render: (_, record) => record.event.type.name,
  },
  {
    title: 'Hosted',
    key: 'hosted',
    render: (_, record) => record.event.host.name,
  },
];

const Events = ({ childId }) => {
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const pageNumber = queryParams.get('page') || 1;
  const { data, isFetching } = useGetChildEventsQuery({ childId, pageNumber });

  return (
    <Table
      columns={columns}
      dataSource={data?.data}
      rowKey="attendId"
      loading={isFetching}
      pageInfo={data}
      size="small"
    />
  );
};

export default memo(Events);
